export const environment = {
  production: false,
  broad_website: 'https://site.dev.broadfactor.com/',
  antecipa_plataforma: 'http://plataforma.dev.antecipagov.com.br/'
}
